import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './App.css';

// Import images
import PocketMoney from './images/PocketMoney.png';
import royal from './images/royal.png';
import Umba from './images/Umba.png';
import Dashmesh from './images/Dashmesh.jpg';
import contegrate from './images/contegrate.jpg';
import kbl from './images/kbl.png';
import platinum from './images/platinum.jpg';
import jmm from './images/jmm.jpg';
import Skyline from './images/Skyline.jpg';
import Hindu from './images/Hindu.jpg';
import ysk from './images/ysk.jpg';
import write from './images/write.jpg';



function ProjectCarousel() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: false,
    cssEase: "ease-in-out",
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  const projects = [
    {
      id: 1,
      title: "Pocket Money",
      description: "Mobile recharge & bill payment solution",
      image: PocketMoney
    },
    {
      id: 2,
      title: "Royal Cooling",
      description: "AC repair and maintenance services",
      image: royal
    },
    {
      id: 3,
      title: "Umba",
      description: "Healthcare awareness platform",
      image: Umba
    },
    {
      id: 4,
      title: "Dashmesh",
      description: "Logistics and transportation services",
      image: Dashmesh
    },
    {
      id: 5,
      title: "Contegrate",
      description: "Logotics management system",
      image: contegrate
    },
    {
      id: 6,
      title: "KBL School",
      description: "Educational management system",
      image: kbl
    },
      {
      id: 7,
      title: "platinum",
      description: "platinum Logistics",
      image: platinum
    },
        {
      id: 8,
      title: "Jmm Infotech",
      description: "Jmm Infotech",
      image: jmm
    },
          {
      id: 9,
      title: "Sky Line",
      description: "Bond Related",
      image: Skyline
    },


             {
      id: 10,
      title: "Hindusthan",
      description: "Hindusthan Motors",
      image: Hindu
    },

                {
      id: 11,
      title: "Yogiraj SHree krishna Vidyalya",
      description: "Yogiraj SHree krishna Vidyalya School Located In Sakinaka Mumbai",
      image: ysk
    },
    
                  {
      id: 12,
      title: "The Write CoNNect",
      description: "Write",
      image: write
    },
    
    
  ];

  return (
    <div className="project-showcase">
          <div className="section-header">
        <h3 className="section-subtitle">Latest Projects</h3>
        <h1 className="section-title">Latest Real Company Based Projects</h1>
        <p className="section-description">
          All projects created using C#(ASP.NET MVC ,ASP.NET CORE), React, and MS SQL at <span>JMM INFOTECH</span>
        </p>
      </div>
      
      <div className="carousel-container">
        <Slider {...settings}>
          {projects.map((project) => (
            <div key={project.id} className="project-card-wrapper">
              <div className="project-card">
                <div className="image-container">
                  <img 
                    src={project.image} 
                    alt={project.title}
                    className="project-image"
                  />
                </div>
                <div className="card-content">
                  <span className="project-number">0{project.id}</span>
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default ProjectCarousel;